import { render, staticRenderFns } from "./popup-do.vue?vue&type=template&id=674e0305&scoped=true"
import script from "./popup-do.vue?vue&type=script&lang=js"
export * from "./popup-do.vue?vue&type=script&lang=js"
import style0 from "./popup-do.vue?vue&type=style&index=0&id=674e0305&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e0305",
  null
  
)

export default component.exports